import { useForm, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useCallback, useEffect } from "react";
import { droneSchema } from "../validationSchema";
import { setDroneData } from "../utils/setDroneData";
import { setDoorData } from "../utils/setDoorData";

const useDroneForm = (initialData) => {
  const method = useForm({
    resolver: yupResolver(droneSchema),
    mode: "onChange",
    defaultValues: {
      name: "",
      display_id: "",
      serverId: "",
      base_station_ip: "",
      drones: [],
      doors: [],
    },
  });

  const { control, reset, trigger, watch } = method;

  const serverId = watch("serverId");

  const {
    fields: droneFields,
    append: appendDrones,
    move: moveDrones,
    update: updateDrones,
  } = useFieldArray({
    control,
    name: "drones",
  });
  const {
    fields: doorFields,
    append: appendDoors,
    move: doorsMove,
    update: updateDoors,
    remove: removeDoors,
  } = useFieldArray({
    control,
    name: "doors",
  });

  const handleAddDrones = useCallback(() => {
    appendDrones([setDroneData(), setDroneData(), setDroneData()]);
  }, [appendDrones]);

  const handleAddDoors = useCallback(() => {
    appendDoors([setDoorData()]);
  }, [appendDoors]);
  const handleRemoveDoors = useCallback((index) => {
    removeDoors(index);
  }, [removeDoors]);

  useEffect(() => {
    let temp = {
      name: initialData?.name ?? "",
      display_id: initialData?.display_id ?? "",
      base_station_ip: initialData?.base_station_ip ?? "",
      serverId: initialData?.id ?? "",
      drones: [],
      doors: [],
    };

    if (initialData?.drones?.length) {
      temp.drones = initialData.drones.map(
        ({ display_id, status, type, id, device_id, drone_ip }) =>
          setDroneData(type, display_id, status, id, true, drone_ip, device_id),
      );
    }

    // Always ensure at least 3 drones
    while (temp.drones.length < 3) {
      temp.drones.push(setDroneData());
    }
    if (!!initialData?.doors?.id) {
      temp.doors = [setDoorData({ ...initialData?.doors, isUpdate: true })];
    // } else {
    //   temp.doors = [setDoorData()];
    }
    reset(temp);
  }, [initialData, serverId, reset]);

  // useEffect(() => {
  //   const drones = getValues("drones") || [];
  //   const isValid = drones.some(
  //     (d) => d.type?.trim() && d.status?.trim() && d.droneId?.trim()
  //   );
  //   if (isValid && errors?.drones?.root?.type === "at-least-one-complete") {
  //     clearErrors("drones");
  //   }
  // }, [getValues("drones"), errors?.drones, clearErrors]);

  return {
    ...method,
    droneFields,
    appendDrones,
    moveDrones,
    updateDrones,
    handleAddDrones,
    handleAddDoors,
    handleRemoveDoors,
    doorFields,
    appendDoors,
    doorsMove,
    updateDoors,
    trigger,
  };
};

export default useDroneForm;
